// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Z2PLw","sectionTitle":"Section_sectionTitle__in2ym"};